import { MapPinIcon, MessageIcon, PhoneIcon, MailIcon } from "./icons";
import { GlassCard } from "./ui";
import { digitsOnly } from "./utils";

export const LocationContactsSection = ({ contact, loading, scheduleHours = [] }) => (
    <section id="contactos" className="public-section public-location-section py-10 sm:py-12">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-8">
        <GlassCard className="p-6 hover:shadow-md transition">
          <p className="text-xs sm:text-sm uppercase tracking-wider text-indigo-600 dark:text-indigo-300 font-semibold">Localização & Contactos</p>
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 dark:text-slate-100 mt-1 tracking-tight">Visite-nos ou fale connosco</h2>

          <div className="mt-5 space-y-3 text-slate-800 dark:text-slate-200">
            <div className="flex items-start gap-2">
              <MapPinIcon />
              <div>
                <span className="font-semibold">Endereço:</span>{" "}
                <span className="text-slate-700 dark:text-slate-300">{contact.address}</span>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <PhoneIcon />{" "}
              <span className="font-semibold">Telefone:</span>{" "}
              <a href={`tel:${digitsOnly(contact.phone) || String(contact.phone || "").replace(/\s+/g, "")}`} className="text-slate-700 dark:text-slate-300 hover:text-indigo-600 dark:hover:text-indigo-300">
                {contact.phone}
              </a>
            </div>
            <div className="flex items-center gap-2">
              <MessageIcon />{" "}
              <span className="font-semibold">WhatsApp:</span>{" "}
              <span className="text-slate-700 dark:text-slate-300">{contact.whatsappDisplay || contact.phone}</span>
            </div>
            {contact.email ? (
              <div className="flex items-center gap-2">
                <MailIcon />{" "}
                <span className="font-semibold">E-mail:</span>{" "}
                <a href={`mailto:${contact.email}`} className="text-slate-700 dark:text-slate-300 hover:text-indigo-600 dark:hover:text-indigo-300">
                  {contact.email}
                </a>
              </div>
            ) : null}
          </div>

          <div className="flex flex-wrap gap-3 mt-6">
            <a
              href={contact.whatsappLink || "#"}
              target="_blank"
              rel="noreferrer"
              className="px-4 py-2 rounded-full bg-slate-900 text-white font-semibold shadow-sm hover:bg-slate-800"
            >
              Falar no WhatsApp
            </a>
            {contact.mapUrl ? (
              <a
                href={contact.mapUrl}
                target="_blank"
                rel="noreferrer"
                className="px-4 py-2 rounded-full border border-white dark:border-slate-900/70 bg-white dark:bg-slate-900/60 text-slate-800 dark:text-slate-200 font-semibold shadow-sm hover:bg-white dark:hover:bg-slate-900/75"
              >
                Abrir no Maps
              </a>
            ) : null}
            {contact.phone ? (
              <a
                href={`tel:${digitsOnly(contact.phone) || contact.phone.replace(/\s+/g, "")}`}
                className="px-4 py-2 rounded-full border border-white dark:border-slate-900/70 bg-white dark:bg-slate-900/60 text-slate-800 dark:text-slate-200 font-semibold shadow-sm hover:bg-white dark:hover:bg-slate-900/75"
              >
                Ligar agora
              </a>
            ) : null}
          </div>

          {scheduleHours.length ? (
            <div className="mt-7">
              <p className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-400 font-semibold mb-2">Horários habituais</p>
              <div className="space-y-2 text-slate-700 dark:text-slate-300 text-sm">
                {scheduleHours.map((line, i) => (
                  <div key={`hour-${i}`}>{line}</div>
                ))}
              </div>
            </div>
          ) : null}
        </GlassCard>

        <GlassCard id="localizacao" className="overflow-hidden hover:shadow-md transition">
          {loading ? (
            <div className="h-80 w-full p-6 animate-pulse bg-white dark:bg-slate-900/60">
              <div className="h-6 w-1/2 rounded bg-slate-200 dark:bg-slate-700 mb-4" />
              <div className="h-4 w-2/3 rounded bg-slate-200 dark:bg-slate-700 mb-2" />
              <div className="h-4 w-1/2 rounded bg-slate-200 dark:bg-slate-700" />
            </div>
          ) : contact.mapEmbed ? (
            <div className="h-80 w-full">
              <iframe
                title="Mapa da igreja"
                src={contact.mapEmbed}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="h-full w-full border-0"
                allowFullScreen
              />
            </div>
          ) : (
            <div className="h-80 w-full bg-gradient-to-br from-indigo-200 dark:from-indigo-800/40 via-sky-100 dark:via-sky-900/40 to-white dark:to-slate-900 flex items-center justify-center relative">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(79,70,229,0.14),transparent_35%),radial-gradient(circle_at_80%_0%,rgba(59,130,246,0.12),transparent_30%)]" />
              <div className="relative text-center space-y-2 px-6">
                <div className="text-3xl font-extrabold text-indigo-800 dark:text-indigo-200">{contact.brandName}</div>
                <p className="text-slate-700 dark:text-slate-300">{contact.address}</p>
                {contact.mapUrl ? (
                  <a href={contact.mapUrl} target="_blank" rel="noreferrer" className="text-indigo-700 dark:text-indigo-300 font-semibold hover:text-indigo-500 dark:hover:text-indigo-300">
                    Ver no Google Maps →
                  </a>
                ) : null}
              </div>
            </div>
          )}
        </GlassCard>
      </div>
    </div>
  </section>
);
